import { render, staticRenderFns } from "./full-lessons.vue?vue&type=template&id=7a88104e&"
import script from "./full-lessons.vue?vue&type=script&lang=js&"
export * from "./full-lessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports